import "./styles.css";

import SearchRobots from "./components/SearchRobots";

function App() {
  return (
    <div className="App">
      <SearchRobots />
    </div>
  );
}

export default App;
